export const STYLES = `
/* ===== ANIMATIONS ===== */
@keyframes gw-fade-in {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes gw-fade-in-up {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes gw-scale-in {
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
}

@keyframes gw-shimmer {
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}

@keyframes gw-checkmark {
  0% { stroke-dashoffset: 24; }
  100% { stroke-dashoffset: 0; }
}

@keyframes gw-progress-fill {
  from { width: 0; }
}

.gw-delivery {
  font-family: 'Onest', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  margin: 20px 0;
  color: #2d2d2d;
  animation: gw-fade-in 0.3s ease-out;
}

.gw-delivery * {
  box-sizing: border-box;
}

/* CRITICAL: Hide Tilda duplicate price rows */
.t706__cartwin-totalamount-info {
  display: none !important;
}

.t706__cartpage-prodamount.t706__cartwin-prodamount-wrap {
  display: none !important;
}

/* Header */
.gw-delivery__header {
  margin-bottom: 16px;
}

.gw-delivery__title {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  color: #2d2d2d;
}

/* City Input */
.gw-delivery__city {
  margin-bottom: 20px;
}

.gw-delivery__label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #555;
}

.gw-delivery__city-wrapper {
  position: relative;
}

.gw-delivery__city-input {
  width: 100%;
  padding: 12px 16px;
  border: 1.5px solid #dce0d9;
  border-radius: 10px;
  font-size: 16px;
  font-family: inherit;
  outline: none;
  transition: border-color 0.25s ease, box-shadow 0.25s ease;
  background: #fff;
}

.gw-delivery__city-input:focus {
  border-color: #3a7d44;
  box-shadow: 0 0 0 3px rgba(58, 125, 68, 0.12);
}

.gw-delivery__city-input::placeholder {
  color: #aaa;
}
/* Suggestions Dropdown */
.gw-delivery__suggestions {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: #fff;
  border: 1.5px solid #dce0d9;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  max-height: 280px;
  overflow-y: auto;
  display: none;
  animation: gw-fade-in-up 0.2s ease-out;
}

.gw-delivery__suggestions--visible {
  display: block;
}

.gw-delivery__suggestion {
  padding: 12px 16px;
  cursor: pointer;
  transition: background 0.15s ease;
  border-bottom: 1px solid #f2f3f0;
  min-height: 44px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.gw-delivery__suggestion:last-child {
  border-bottom: none;
}

.gw-delivery__suggestion:hover,
.gw-delivery__suggestion--active {
  background: #f4f8f4;
}

.gw-delivery__suggestion-name {
  font-weight: 500;
  color: #2d2d2d;
}

.gw-delivery__suggestion-region {
  font-size: 13px;
  color: #777;
  margin-top: 2px;
}

/* Delivery Options */
.gw-delivery__options {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* Options Group */
.gw-delivery__options-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.gw-delivery__options-group-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #555;
  padding: 0 4px;
}

.gw-delivery__options-group-icon {
  color: #777;
  flex-shrink: 0;
}

.gw-delivery__option {
  display: block;
  padding: 16px;
  border: 2px solid #e8ebe5;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.25s ease;
  background: #fff;
  min-height: 44px;
}

.gw-delivery__option:hover {
  border-color: #3a7d44;
  box-shadow: 0 2px 8px rgba(58, 125, 68, 0.08);
}

.gw-delivery__option--selected {
  border-color: #3a7d44;
  background: linear-gradient(to right, rgba(58, 125, 68, 0.04), transparent);
}

.gw-delivery__option input {
  display: none;
}

.gw-delivery__option-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
}

.gw-delivery__option-name {
  font-weight: 600;
  font-size: 15px;
  color: #2d2d2d;
}

.gw-delivery__option-price {
  font-weight: 700;
  font-size: 16px;
  color: #2d2d2d;
  white-space: nowrap;
  margin-left: 12px;
}

.gw-delivery__option-price--free {
  color: #3a7d44;
}

.gw-delivery__option-details {
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 13px;
  color: #777;
}

.gw-delivery__option-days {
  display: flex;
  align-items: center;
  gap: 4px;
}

.gw-delivery__option-days svg {
  flex-shrink: 0;
  color: #777;
}

.gw-delivery__option-pvz {
  display: flex;
  align-items: center;
  gap: 4px;
}

.gw-delivery__option-pvz svg {
  flex-shrink: 0;
  color: #777;
}
/* Courier info */
.gw-delivery__courier-info {
  margin-top: 12px;
}

.gw-delivery__courier-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: #e8f0e8;
  color: #2e6b35;
  font-size: 12px;
  font-weight: 500;
  border-radius: 20px;
}

.gw-delivery__courier-badge::before {
  content: '';
  display: inline-block;
  width: 14px;
  height: 14px;
  background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%232e6b35'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6'/%3E%3C/svg%3E") center/contain no-repeat;
}

/* PVZ Button */
.gw-delivery__pvz-btn {
  margin-top: 12px;
  padding: 10px 16px;
  background: #fff;
  border: 1.5px solid #3a7d44;
  border-radius: 8px;
  color: #3a7d44;
  font-size: 14px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  transition: all 0.25s ease;
  width: 100%;
  min-height: 44px;
}

.gw-delivery__pvz-btn:hover {
  background: #3a7d44;
  color: #fff;
}

/* Selected PVZ */
.gw-delivery__selected-pvz {
  margin-top: 12px;
  padding: 12px;
  background: #f8f9f7;
  border-radius: 8px;
  font-size: 13px;
}

.gw-delivery__selected-pvz-name {
  font-weight: 600;
  color: #2d2d2d;
  margin-bottom: 4px;
}

.gw-delivery__selected-pvz-address {
  color: #777;
}

.gw-delivery__selected-pvz-change {
  color: #3a7d44;
  cursor: pointer;
  font-size: 13px;
  margin-top: 8px;
  display: inline-block;
}

.gw-delivery__selected-pvz-change:hover {
  text-decoration: underline;
}

/* Loading */
.gw-delivery__loading {
  text-align: center;
  padding: 40px 20px;
  color: #777;
}

.gw-delivery__spinner {
  width: 32px;
  height: 32px;
  border: 3px solid #e8ebe5;
  border-top-color: #3a7d44;
  border-radius: 50%;
  margin: 0 auto 16px;
  animation: gw-spin 0.8s linear infinite;
}

@keyframes gw-spin {
  to { transform: rotate(360deg); }
}

/* Skeleton loading for price breakdown */
@keyframes gw-skeleton-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
}

.gw-price-skeleton {
  display: inline-block;
  background: linear-gradient(90deg, #edeee9 25%, #dce0d9 50%, #edeee9 75%);
  background-size: 200% 100%;
  animation: gw-shimmer 1.5s ease-in-out infinite;
  border-radius: 6px;
  height: 1em;
  min-width: 60px;
}

.gw-price-fade {
  transition: opacity 0.2s ease-out;
}

.gw-price-fade-out {
  opacity: 0.3;
}

.gw-price-fade-in {
  opacity: 1;
}
/* ===== SKELETON CARDS ===== */
.gw-delivery__skeleton-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  background: #fff;
  border: 2px solid #e8ebe5;
  border-radius: 12px;
  animation: gw-fade-in-up 0.3s ease-out;
}

.gw-delivery__skeleton-logo {
  width: 48px;
  height: 48px;
  border-radius: 10px;
  background: linear-gradient(90deg, #edeee9 25%, #dce0d9 50%, #edeee9 75%);
  background-size: 200% 100%;
  animation: gw-shimmer 1.5s ease-in-out infinite;
  flex-shrink: 0;
}

.gw-delivery__skeleton-lines {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.gw-delivery__skeleton-line {
  height: 14px;
  border-radius: 6px;
  background: linear-gradient(90deg, #edeee9 25%, #dce0d9 50%, #edeee9 75%);
  background-size: 200% 100%;
  animation: gw-shimmer 1.5s ease-in-out infinite;
}

.gw-delivery__skeleton-line--short {
  width: 60%;
}

.gw-delivery__skeleton-line--xs {
  width: 35%;
}

.gw-delivery__skeleton-price {
  width: 70px;
  height: 22px;
  border-radius: 6px;
  background: linear-gradient(90deg, #edeee9 25%, #dce0d9 50%, #edeee9 75%);
  background-size: 200% 100%;
  animation: gw-shimmer 1.5s ease-in-out infinite;
  flex-shrink: 0;
}

/* Empty state */
.gw-delivery__empty {
  text-align: center;
  padding: 30px 20px;
  color: #777;
  font-size: 14px;
}

/* Error */
.gw-delivery__error {
  padding: 16px 20px;
  background: #fef6f4;
  border: 1.5px solid #f5c6c2;
  border-radius: 12px;
  color: #b74038;
  font-size: 14px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  animation: gw-fade-in-up 0.3s ease-out;
}

.gw-delivery__error-icon {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  margin-top: 1px;
}

.gw-delivery__error-text {
  flex: 1;
  line-height: 1.5;
}

.gw-delivery__error-retry {
  display: inline-block;
  margin-top: 8px;
  padding: 6px 14px;
  background: #fff;
  border: 1px solid #f5c6c2;
  border-radius: 8px;
  color: #b74038;
  font-size: 13px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  transition: all 0.2s ease;
  min-height: 36px;
}

.gw-delivery__error-retry:hover {
  background: #fef6f4;
  border-color: #b74038;
}

/* Message (remaining for free delivery) */
.gw-delivery__message {
  padding: 14px 16px;
  background: linear-gradient(135deg, #fefcf2 0%, #fef9e7 100%);
  border: 1.5px solid #f5dfa0;
  border-radius: 12px;
  color: #8a6d1b;
  font-size: 14px;
  margin-top: 16px;
  animation: gw-fade-in-up 0.3s ease-out;
}

.gw-delivery__message-content {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.gw-delivery__message-icon {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
}

.gw-delivery__message-text {
  font-weight: 500;
}

/* Progress bar for free delivery */
.gw-delivery__progress-bar {
  width: 100%;
  height: 6px;
  background: rgba(138, 109, 27, 0.12);
  border-radius: 3px;
  overflow: hidden;
}

.gw-delivery__progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #3a7d44, #5a9e64);
  border-radius: 3px;
  transition: width 0.6s ease-out;
  animation: gw-progress-fill 0.8s ease-out;
}
/* Map Modal */
.gw-delivery__map-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 10000010 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  animation: gw-fade-in 0.2s ease-out;
}

.gw-delivery__map-modal {
  background: #fff;
  border-radius: 16px;
  width: 100%;
  max-width: 1100px;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  z-index: 10000011 !important;
  position: relative;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
  animation: gw-scale-in 0.25s ease-out;
  font-family: 'Onest', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  color: #2d2d2d;
}

.gw-delivery__map-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #e8ebe5;
}

.gw-delivery__map-title {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
}

.gw-delivery__map-close {
  width: 36px;
  height: 36px;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 24px;
  color: #777;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  transition: all 0.15s ease;
  min-height: 44px;
  min-width: 44px;
}

.gw-delivery__map-close:hover {
  background: #f2f3f0;
  color: #2d2d2d;
}

.gw-delivery__map-content {
  display: flex;
  flex: 1;
  min-height: 500px;
  overflow: hidden;
}

.gw-delivery__map-container {
  flex: 1;
  min-height: 500px;
  position: relative;
}

.gw-delivery__pvz-list {
  width: 350px;
  border-left: 1px solid #e8ebe5;
  overflow-y: auto;
  max-height: 600px;
}

.gw-delivery__pvz-item {
  padding: 14px 16px;
  border-bottom: 1px solid #f2f3f0;
  cursor: pointer;
  transition: all 0.15s ease;
  min-height: 44px;
}

.gw-delivery__pvz-item:hover {
  background: #f8f9f7;
}

.gw-delivery__pvz-item--selected {
  background: #f0f7f1;
  border-left: 3px solid #3a7d44;
}

.gw-delivery__pvz-item-name {
  font-weight: 600;
  font-size: 14px;
  color: #2d2d2d;
  margin-bottom: 4px;
}

.gw-delivery__pvz-item-address {
  font-size: 13px;
  color: #777;
  margin-bottom: 4px;
}

.gw-delivery__pvz-item-time {
  font-size: 12px;
  color: #999;
}

.gw-delivery__map-filters {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 20px;
  border-bottom: 1px solid #e8ebe5;
  flex-wrap: wrap;
  background: #fafbf9;
}

.gw-delivery__map-filter-group {
  display: flex;
  align-items: center;
  gap: 6px;
}

.gw-delivery__map-filter-label {
  font-size: 12px;
  color: #888;
  font-weight: 500;
  white-space: nowrap;
}

.gw-delivery__map-filter-btn {
  padding: 5px 12px;
  border: 1px solid #dde0d8;
  border-radius: 16px;
  background: #fff !important;
  font-size: 12px !important;
  font-weight: 500;
  color: #555 !important;
  cursor: pointer;
  transition: all 0.15s ease;
  font-family: inherit;
  white-space: nowrap;
  min-height: 30px;
  line-height: 1.3;
}

.gw-delivery__map-filter-btn:hover {
  border-color: #3a7d44;
  color: #3a7d44 !important;
}

.gw-delivery__map-filter-btn--active {
  background: #3a7d44 !important;
  border-color: #3a7d44;
  color: #fff !important;
}

.gw-delivery__map-search {
  width: 100%;
  min-width: 160px;
  padding: 6px 12px;
  border: 1px solid #dde0d8;
  border-radius: 8px;
  font-size: 13px;
  font-family: inherit;
  outline: none;
  transition: border-color 0.15s ease;
  min-height: 32px;
}

.gw-delivery__map-search:focus {
  border-color: #3a7d44;
}

.gw-delivery__pvz-list-count {
  padding: 8px 16px;
  font-size: 12px;
  color: #999;
  border-bottom: 1px solid #f2f3f0;
  background: #fafbf9;
}

.gw-delivery__pvz-item-header {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
}

.gw-delivery__pvz-item-provider {
  font-size: 10px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 4px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.gw-delivery__pvz-item-provider--cdek {
  background: #e8f5e9;
  color: #2e7d32;
}

.gw-delivery__pvz-item-provider--yandex {
  background: #fff8e1;
  color: #f57f17;
}

.gw-delivery__pvz-item-type-badge {
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 4px;
  background: #f2f3f0;
  color: #777;
}

.gw-delivery__pvz-item-type-badge--pvz {
  background: #e3f2fd;
  color: #1565c0;
}

.gw-delivery__pvz-item-type-badge--postamat {
  background: #f3e5f5;
  color: #7b1fa2;
}

.gw-delivery__pvz-item-phone {
  font-size: 12px;
  color: #3a7d44;
  margin-top: 4px;
}

.gw-delivery__map-selected-pvz {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  border-top: 1px solid #e8ebe5;
  background: #f0f7f1;
  gap: 16px;
}

.gw-delivery__map-selected-pvz-info {
  flex: 1;
  min-width: 0;
}

.gw-delivery__map-selected-pvz-name {
  font-weight: 600;
  font-size: 14px;
  color: #2d2d2d;
  margin-bottom: 2px;
}

.gw-delivery__map-selected-pvz-address {
  font-size: 13px;
  color: #666;
}

.gw-delivery__map-selected-pvz-time {
  font-size: 12px;
  color: #888;
}

.gw-delivery__map-selected-pvz-btn {
  padding: 10px 24px;
  background: #3a7d44;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease;
  font-family: inherit;
  white-space: nowrap;
  min-height: 44px;
}

.gw-delivery__map-selected-pvz-btn:hover {
  background: #2d6635;
}

/* ===== YANDEX MAP BALLOON ===== */
.gw-balloon {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  line-height: 1.4;
  box-sizing: border-box;
}
.gw-balloon__badges {
  display: flex;
  gap: 6px;
  margin-bottom: 8px;
}
.gw-balloon__badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.4;
}
.gw-balloon__name {
  font-size: 14px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 4px;
}
.gw-balloon__address {
  font-size: 13px;
  color: #333;
  margin-bottom: 6px;
}
.gw-balloon__time {
  font-size: 12px;
  color: #888;
  margin-bottom: 2px;
}
.gw-balloon__phone {
  font-size: 12px;
  color: #888;
  margin-bottom: 2px;
}
.gw-balloon__btn {
  margin-top: 10px;
  padding: 9px 16px;
  background: #3a7d44;
  color: #fff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  width: 100%;
  font-size: 13px;
  font-weight: 500;
  font-family: inherit;
  transition: background 0.15s;
  box-sizing: border-box;
}
.gw-balloon__btn:hover {
  background: #2d6635;
}
/* Override ymaps balloon wrapper for rounded corners */
[class*="balloon__layout"] {
  border-radius: 14px !important;
  overflow: hidden;
}
[class*="balloon__content"] {
  padding: 14px 16px !important;
  margin: 0 !important;
  overflow: visible !important;
}
[class*="balloon__content"] > * {
  max-width: 100%;
  box-sizing: border-box;
}
/* Hide default ymaps balloon close button styling conflict */
[class*="balloon__close-button"] {
  top: 8px !important;
  right: 8px !important;
}

/* ===== DELIVERY CATEGORY BADGES ===== */
.gw-delivery__badges {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
  padding: 2px;
}

.gw-delivery__badges::-webkit-scrollbar {
  display: none;
}

.gw-delivery__badge {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 14px 10px 12px;
  min-width: 88px;
  flex: 1;
  background: #fff;
  border: 2px solid #e8ebe5;
  border-radius: 14px;
  cursor: pointer;
  transition: all 0.25s ease;
  text-align: center;
  position: relative;
  min-height: 44px;
}

.gw-delivery__badge:hover:not(.gw-delivery__badge--disabled) {
  border-color: #3a7d44;
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(58, 125, 68, 0.12);
}

.gw-delivery__badge--active {
  border-color: #3a7d44;
  background: linear-gradient(to bottom, rgba(58, 125, 68, 0.06), #fff);
  box-shadow: 0 2px 8px rgba(58, 125, 68, 0.1);
}

.gw-delivery__badge--disabled {
  opacity: 0.45;
  cursor: not-allowed;
  background: #f8f9f7;
}

.gw-delivery__badge-icon {
  font-size: 22px;
  margin-bottom: 6px;
  line-height: 1;
  transition: transform 0.25s ease;
}

.gw-delivery__badge--active .gw-delivery__badge-icon {
  color: #3a7d44;
  transform: scale(1.1);
}

.gw-delivery__badge-label {
  font-weight: 600;
  font-size: 13px;
  color: #2d2d2d;
  margin-bottom: 2px;
}

.gw-delivery__badge-subtitle {
  font-size: 11px;
  color: #999;
  line-height: 1.3;
}

.gw-delivery__badge-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 18px;
  padding: 0 5px;
  background: #e8ebe5;
  border-radius: 9px;
  font-size: 10px;
  font-weight: 700;
  color: #555;
  margin-top: 4px;
  transition: all 0.25s ease;
}

.gw-delivery__badge--active .gw-delivery__badge-count {
  background: #3a7d44;
  color: #fff;
}

/* ===== PROVIDER FILTER PILLS ===== */
.gw-delivery__provider-filters {
  display: flex;
  gap: 6px;
  margin-bottom: 12px;
}

.gw-delivery__provider-filter {
  padding: 5px 14px;
  background: #f4f5f3;
  border: 1.5px solid transparent;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  color: #666;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  line-height: 1.4;
}

.gw-delivery__provider-filter:hover {
  background: #e8ebe5;
  color: #333;
}

.gw-delivery__provider-filter--active {
  background: #3a7d44;
  color: #fff;
  border-color: #3a7d44;
}

.gw-delivery__provider-filter--active:hover {
  background: #2d6635;
  color: #fff;
}
/* ===== TARIFF CARDS ===== */
.gw-delivery__tariffs {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
}

.gw-delivery__tariff-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  background: #fff;
  border: 2px solid #e8ebe5;
  border-radius: 14px;
  cursor: pointer;
  transition: all 0.25s ease;
  animation: gw-fade-in-up 0.3s ease-out both;
  position: relative;
}

.gw-delivery__tariff-card:nth-child(1) { animation-delay: 0ms; }
.gw-delivery__tariff-card:nth-child(2) { animation-delay: 50ms; }
.gw-delivery__tariff-card:nth-child(3) { animation-delay: 100ms; }
.gw-delivery__tariff-card:nth-child(4) { animation-delay: 150ms; }
.gw-delivery__tariff-card:nth-child(5) { animation-delay: 200ms; }

.gw-delivery__tariff-card:hover {
  border-color: #3a7d44;
  box-shadow: 0 3px 12px rgba(58, 125, 68, 0.08);
}

.gw-delivery__tariff-card--selected {
  border-color: #3a7d44;
  background: linear-gradient(135deg, rgba(58, 125, 68, 0.04) 0%, rgba(58, 125, 68, 0.01) 100%);
  box-shadow: 0 2px 8px rgba(58, 125, 68, 0.1);
}

.gw-delivery__tariff-check {
  position: absolute;
  top: -6px;
  right: -6px;
  width: 22px;
  height: 22px;
  background: #3a7d44;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: gw-scale-in 0.25s ease-out;
  box-shadow: 0 2px 6px rgba(58, 125, 68, 0.3);
}

.gw-delivery__tariff-check svg {
  width: 12px;
  height: 12px;
  stroke: #fff;
  stroke-width: 3;
  fill: none;
  stroke-dasharray: 24;
  stroke-dashoffset: 0;
  animation: gw-checkmark 0.3s ease-out;
}

.gw-delivery__tariff-info {
  display: flex;
  align-items: center;
  gap: 14px;
  flex: 1;
  min-width: 0;
}

.gw-delivery__tariff-logo {
  width: 44px;
  height: 44px;
  object-fit: contain;
  border-radius: 10px;
  background: #f8f9f7;
  padding: 6px;
  flex-shrink: 0;
}

.gw-delivery__tariff-details {
  flex: 1;
  min-width: 0;
}

.gw-delivery__tariff-name {
  font-weight: 600;
  font-size: 14px;
  color: #2d2d2d;
  margin-bottom: 3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.gw-delivery__tariff-days {
  font-size: 13px;
  color: #777;
}

.gw-delivery__tariff-pricing {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  flex-shrink: 0;
  margin-left: 12px;
}

.gw-delivery__tariff-price {
  font-weight: 700;
  font-size: 17px;
  color: #2d2d2d;
}

.gw-delivery__tariff-price--free {
  color: #3a7d44;
}

/* Free delivery badge */
.gw-delivery__free-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 8px;
  background: linear-gradient(135deg, #e8f0e8, #d4e8d4);
  color: #2e6b35;
  font-size: 11px;
  font-weight: 600;
  border-radius: 6px;
  white-space: nowrap;
  letter-spacing: 0.02em;
}

/* Cheapest / Fastest badges */
.gw-delivery__tariff-badge {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 2px 7px;
  font-size: 10px;
  font-weight: 600;
  border-radius: 5px;
  white-space: nowrap;
  letter-spacing: 0.02em;
}

.gw-delivery__tariff-badge--cheapest {
  background: linear-gradient(135deg, #e8f0e8, #d4e8d4);
  color: #2e6b35;
}

.gw-delivery__tariff-badge--fastest {
  background: linear-gradient(135deg, #e8eef8, #d4e0f0);
  color: #2d5aa0;
}

.gw-delivery__tariff-select {
  padding: 8px 16px;
  background: #3a7d44;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-height: 36px;
}

.gw-delivery__tariff-select:hover {
  background: #2e6b35;
}

.gw-delivery__tariff-card--selected .gw-delivery__tariff-select {
  background: #e8f0e8;
  color: #3a7d44;
}

.gw-delivery__tariff-select--selected {
  background: #e8f0e8 !important;
  color: #3a7d44 !important;
  cursor: default;
}
/* PVZ select button in tariff card */
.gw-delivery__pvz-select-btn,
.gw-delivery__pvz-change-btn {
  width: 100%;
  margin-top: 12px;
  padding: 10px 16px;
  background: #fff;
  border: 1.5px solid #3a7d44;
  border-radius: 10px;
  color: #3a7d44;
  font-size: 14px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  transition: all 0.25s ease;
  min-height: 44px;
}

.gw-delivery__pvz-select-btn:hover,
.gw-delivery__pvz-change-btn:hover {
  background: #3a7d44;
  color: #fff;
}

/* Selected PVZ info in tariff card */
.gw-delivery__selected-pvz-info {
  width: 100%;
  margin-top: 12px;
  padding: 12px;
  background: #f8f9f7;
  border-radius: 10px;
  font-size: 13px;
  animation: gw-fade-in-up 0.2s ease-out;
}

.gw-delivery__selected-pvz-info .gw-delivery__selected-pvz-name {
  font-weight: 600;
  color: #2d2d2d;
  margin-bottom: 4px;
}

.gw-delivery__selected-pvz-info .gw-delivery__selected-pvz-address {
  color: #777;
  margin-bottom: 8px;
}

/* Make tariff card flex-wrap for PVZ content */
.gw-delivery__tariff-card {
  flex-wrap: wrap;
}

/* ===== COURIER ADDRESS FORM ===== */
.gw-delivery__address {
  margin-top: 20px;
  padding: 20px;
  background: #f8f9f7;
  border-radius: 14px;
  border: 1.5px solid #e8ebe5;
  animation: gw-fade-in-up 0.3s ease-out;
}

.gw-delivery__address-title {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 16px 0;
  color: #2d2d2d;
}

.gw-delivery__address-field {
  margin-bottom: 16px;
}

.gw-delivery__address-field:last-child {
  margin-bottom: 0;
}

.gw-delivery__address-field label {
  display: block;
  font-size: 13px;
  font-weight: 500;
  color: #555;
  margin-bottom: 6px;
}

.gw-delivery__address-input {
  width: 100%;
  padding: 12px 14px;
  border: 1.5px solid #dce0d9;
  border-radius: 10px;
  font-size: 15px;
  font-family: inherit;
  outline: none;
  transition: border-color 0.25s ease, box-shadow 0.25s ease;
  background: #fff;
  min-height: 44px;
}

.gw-delivery__address-input:focus {
  border-color: #3a7d44;
  box-shadow: 0 0 0 3px rgba(58, 125, 68, 0.12);
}

.gw-delivery__address-input::placeholder {
  color: #aaa;
}

.gw-delivery__address-row {
  display: flex;
  gap: 16px;
}

.gw-delivery__address-field--half {
  flex: 1;
}

.gw-delivery__address-field--third {
  flex: 1;
  max-width: 33%;
}

.gw-delivery__address-textarea {
  width: 100%;
  padding: 12px 14px;
  border: 1.5px solid #dce0d9;
  border-radius: 10px;
  font-size: 15px;
  font-family: inherit;
  outline: none;
  resize: vertical;
  min-height: 60px;
  transition: border-color 0.25s ease, box-shadow 0.25s ease;
  background: #fff;
}

.gw-delivery__address-textarea:focus {
  border-color: #3a7d44;
  box-shadow: 0 0 0 3px rgba(58, 125, 68, 0.12);
}

/* Street autocomplete */
.gw-delivery__address-autocomplete {
  position: relative;
}

.gw-delivery__street-suggestions {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: #fff;
  border: 1.5px solid #dce0d9;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  max-height: 200px;
  overflow-y: auto;
  display: none;
  animation: gw-fade-in-up 0.2s ease-out;
}

.gw-delivery__street-suggestions--visible {
  display: block;
}

.gw-delivery__street-suggestion {
  padding: 12px 14px;
  cursor: pointer;
  transition: background 0.15s ease;
  border-bottom: 1px solid #f2f3f0;
  font-size: 14px;
  min-height: 44px;
  display: flex;
  align-items: center;
}

.gw-delivery__street-suggestion:last-child {
  border-bottom: none;
}

.gw-delivery__street-suggestion:hover {
  background: #f4f8f4;
}
/* ===== PICKUP PROMPT (map-first flow) ===== */
.gw-delivery__pickup-prompt {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  padding: 32px 20px;
  background: #f8f9f7;
  border-radius: 14px;
  border: 2px dashed #dce0d9;
  text-align: center;
  animation: gw-fade-in-up 0.3s ease-out;
}

.gw-delivery__pickup-prompt-icon {
  color: #3a7d44;
  opacity: 0.7;
}

.gw-delivery__pickup-prompt-text {
  font-size: 15px;
  font-weight: 500;
  color: #555;
}

.gw-delivery__pickup-prompt-btn {
  padding: 12px 28px;
  background: #3a7d44;
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: all 0.25s ease;
  min-height: 44px;
}

.gw-delivery__pickup-prompt-btn:hover {
  background: #2d6635;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(58, 125, 68, 0.2);
}

/* ===== PICKUP SUMMARY (after PVZ selected) ===== */
.gw-delivery__pickup-summary {
  background: #fff;
  border: 2px solid #3a7d44;
  border-radius: 14px;
  padding: 16px;
  animation: gw-fade-in-up 0.3s ease-out;
  position: relative;
}

.gw-delivery__pickup-summary::before {
  content: '';
  position: absolute;
  top: -6px;
  right: -6px;
  width: 22px;
  height: 22px;
  background: #3a7d44;
  border-radius: 50%;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='3'%3E%3Cpolyline points='20 6 9 17 4 12'/%3E%3C/svg%3E");
  background-size: 12px;
  background-position: center;
  background-repeat: no-repeat;
  box-shadow: 0 2px 6px rgba(58, 125, 68, 0.3);
  animation: gw-scale-in 0.25s ease-out;
}

.gw-delivery__pickup-summary-header {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}

.gw-delivery__pickup-summary-info {
  flex: 1;
  min-width: 0;
}

.gw-delivery__pickup-summary-provider {
  display: flex;
  gap: 6px;
  margin-bottom: 6px;
}

.gw-delivery__pickup-summary-badge {
  display: inline-block;
  font-size: 10px;
  font-weight: 600;
  padding: 2px 7px;
  border-radius: 4px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.gw-delivery__pickup-summary-badge--cdek {
  background: #e8f5e9;
  color: #2e7d32;
}

.gw-delivery__pickup-summary-badge--yandex {
  background: #fff8e1;
  color: #f57f17;
}

.gw-delivery__pickup-summary-badge--type {
  background: #f2f3f0;
  color: #777;
}

.gw-delivery__pickup-summary-name {
  font-weight: 600;
  font-size: 14px;
  color: #2d2d2d;
  margin-bottom: 3px;
}

.gw-delivery__pickup-summary-address {
  font-size: 13px;
  color: #777;
  margin-bottom: 4px;
}

.gw-delivery__pickup-summary-hours {
  font-size: 12px;
  color: #888;
  display: flex;
  align-items: center;
  gap: 4px;
}

.gw-delivery__pickup-summary-price {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  flex-shrink: 0;
  margin-left: 12px;
}

.gw-delivery__pickup-summary-days {
  font-size: 13px;
  color: #777;
}

.gw-delivery__pickup-change-btn {
  width: 100%;
  margin-top: 14px;
  padding: 10px 16px;
  background: #fff;
  border: 1.5px solid #3a7d44;
  border-radius: 10px;
  color: #3a7d44;
  font-size: 14px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  transition: all 0.25s ease;
  min-height: 44px;
}

.gw-delivery__pickup-change-btn:hover {
  background: #3a7d44;
  color: #fff;
}

/* ===== GREENWAX PICKUP INFO ===== */
.gw-delivery__greenwax-info {
  padding: 20px;
  background: linear-gradient(135deg, #f0f7f1 0%, #e4efe5 100%);
  border-radius: 14px;
  border: 1.5px solid #c3dbc5;
  margin-bottom: 20px;
  animation: gw-fade-in-up 0.3s ease-out;
}

.gw-delivery__greenwax-title {
  font-weight: 600;
  font-size: 16px;
  color: #2d2d2d;
  margin: 0 0 12px 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.gw-delivery__greenwax-icon {
  width: 22px;
  height: 22px;
  color: #3a7d44;
  flex-shrink: 0;
}

.gw-delivery__greenwax-address {
  font-size: 14px;
  color: #444;
  margin-bottom: 8px;
  display: flex;
  align-items: flex-start;
  gap: 6px;
}

.gw-delivery__greenwax-worktime {
  font-size: 13px;
  color: #666;
  display: flex;
  align-items: flex-start;
  gap: 6px;
}

.gw-delivery__greenwax-price {
  margin-top: 14px;
  font-weight: 700;
  font-size: 18px;
  color: #3a7d44;
}

/* ===== NO OPTIONS MESSAGE ===== */
.gw-delivery__no-options {
  padding: 28px;
  text-align: center;
  background: #f8f9f7;
  border-radius: 14px;
  color: #777;
  animation: gw-fade-in 0.3s ease-out;
}

.gw-delivery__no-options-icon {
  font-size: 32px;
  margin-bottom: 12px;
}

.gw-delivery__no-options-text {
  font-size: 14px;
  line-height: 1.5;
}

/* ===== SECTION TRANSITIONS ===== */
.gw-delivery__tariffs-container,
.gw-delivery__badges-container,
.gw-delivery__address-container {
  transition: opacity 0.25s ease, max-height 0.3s ease;
}

/* ===== MOBILE FLOATING FILTER BADGES (desktop: hidden) ===== */
.gw-delivery__mobile-filters {
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 20;
  display: none;
  gap: 6px;
  flex-wrap: wrap;
}

.gw-delivery__mobile-filter-btn {
  padding: 6px 14px;
  border: none;
  border-radius: 20px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.12);
  font-size: 13px;
  font-weight: 600;
  color: #555;
  cursor: pointer;
  font-family: inherit;
  transition: all 0.15s ease;
  white-space: nowrap;
}

.gw-delivery__mobile-filter-btn--active {
  background: #3a7d44;
  color: #fff;
  box-shadow: 0 2px 8px rgba(58, 125, 68, 0.3);
}

/* ===== FLOATING CLOSE BUTTON (desktop: hidden) ===== */
.gw-delivery__map-close-float {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 20;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #fff;
  border: none;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  display: none;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  color: #555;
  cursor: pointer;
  line-height: 1;
  padding: 0;
}

/* ===== BOTTOM SHEET (desktop: hidden) ===== */
.gw-delivery__bottom-sheet {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 15;
  background: #fff;
  border-radius: 16px 16px 0 0;
  box-shadow: 0 -4px 20px rgba(0,0,0,0.12);
  transition: max-height 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  display: none;
  overflow: hidden;
  width: 100%;
  max-width: 100vw;
  box-sizing: border-box;
}

.gw-delivery__bottom-sheet-drag-zone {
  touch-action: none;
  cursor: grab;
  padding: 6px 0 0;
}

.gw-delivery__bottom-sheet-handle {
  width: 36px;
  height: 4px;
  background: #ddd;
  border-radius: 2px;
  margin: 4px auto 8px;
}

.gw-delivery__bottom-sheet--collapsed {
  max-height: calc(80px + env(safe-area-inset-bottom, 0px));
}

.gw-delivery__bottom-sheet--expanded {
  max-height: 60vh;
}

.gw-delivery__bottom-sheet--pvz-selected {
  max-height: 50vh;
  overflow-y: auto;
}

/* In pvz-selected state, hide the search to save space */
.gw-delivery__bottom-sheet--pvz-selected .gw-delivery__bottom-sheet-search-wrap {
  display: none;
}

.gw-delivery__bottom-sheet-search-wrap {
  padding: 0 12px;
  padding-bottom: calc(10px + env(safe-area-inset-bottom, 0px));
  box-sizing: border-box;
}

.gw-delivery__bottom-sheet-search {
  width: 100%;
  padding: 10px 14px;
  border: 1.5px solid #e0e0e0;
  border-radius: 10px;
  font-size: 15px;
  font-family: inherit;
  outline: none;
  background: #f8f8f8;
  transition: border-color 0.2s ease, background 0.2s ease;
  box-sizing: border-box;
}

.gw-delivery__bottom-sheet-search:focus {
  border-color: #3a7d44;
  background: #fff;
}

.gw-delivery__bottom-sheet-search::placeholder {
  color: #aaa;
}

.gw-delivery__bottom-sheet-list {
  max-height: calc(60vh - 90px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  border-top: 1px solid #f0f0f0;
}

.gw-delivery__bottom-sheet-list .gw-delivery__pvz-item {
  padding: 12px 14px;
  border-bottom: 1px solid #f2f3f0;
  cursor: pointer;
  transition: background 0.15s ease;
}

.gw-delivery__bottom-sheet-list .gw-delivery__pvz-item:active {
  background: #f0f7f1;
}

.gw-delivery__bottom-sheet-pvz-info {
  padding: 14px 16px;
  padding-bottom: calc(14px + env(safe-area-inset-bottom, 0px));
  box-sizing: border-box;
  overflow: hidden;
}

.gw-delivery__bottom-sheet-pvz-name {
  font-weight: 600;
  font-size: 15px;
  color: #2d2d2d;
  margin-bottom: 4px;
}

.gw-delivery__bottom-sheet-pvz-address {
  font-size: 13px;
  color: #777;
  margin-bottom: 4px;
}

.gw-delivery__bottom-sheet-pvz-time {
  font-size: 12px;
  color: #999;
  margin-bottom: 12px;
}

.gw-delivery__bottom-sheet-pvz-btn {
  width: 100%;
  padding: 14px;
  background: #3a7d44;
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  box-sizing: border-box;
  min-height: 48px;
  transition: background 0.15s ease;
}

.gw-delivery__bottom-sheet-pvz-btn:active {
  background: #2d6635;
}

/* Responsive */
@media (max-width: 768px) {
  /* === MAP MODAL: full-screen on mobile === */
  .gw-delivery__map-overlay {
    padding: 0;
  }

  .gw-delivery__map-overlay {
    overflow: hidden;
  }

  .gw-delivery__map-modal {
    max-width: 100vw;
    width: 100vw;
    max-height: 100%;
    height: 100vh;
    height: 100dvh;
    border-radius: 0;
    overflow: hidden;
  }

  .gw-delivery__map-header {
    display: none;
  }

  .gw-delivery__map-content {
    flex-direction: column;
    flex: 1;
    position: relative;
    overflow: hidden;
    height: 100%;
    width: 100%;
  }

  .gw-delivery__map-container {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
  }

  .gw-delivery__map-filters {
    display: none;
  }

  .gw-delivery__pvz-list {
    display: none;
  }

  .gw-delivery__map-selected-pvz {
    display: none !important;
  }

  /* Show mobile-only elements */
  .gw-delivery__mobile-filters {
    display: flex;
  }

  .gw-delivery__map-close-float {
    display: flex;
  }

  .gw-delivery__bottom-sheet {
    display: block;
  }

  /* === WIDGET LAYOUT === */
  .gw-delivery__badges {
    flex-wrap: nowrap;
    overflow-x: auto;
    gap: 8px;
    padding-bottom: 4px;
    margin-bottom: 16px;
  }

  .gw-delivery__badge {
    min-width: 82px;
    flex: 0 0 auto;
    padding: 12px 8px 10px;
  }

  .gw-delivery__tariff-card {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
    padding: 14px;
  }

  .gw-delivery__tariff-info {
    gap: 10px;
  }

  .gw-delivery__tariff-logo {
    width: 40px;
    height: 40px;
  }

  .gw-delivery__tariff-pricing {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-left: 0;
  }

  .gw-delivery__pickup-summary-header {
    flex-direction: column;
    gap: 10px;
  }

  .gw-delivery__pickup-summary-price {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-left: 0;
  }

  .gw-delivery__address-row {
    flex-direction: column;
    gap: 16px;
  }

  .gw-delivery__address-field--half,
  .gw-delivery__address-field--third {
    max-width: 100%;
  }
}

@media (max-width: 380px) {
  .gw-delivery {
    margin: 12px 0;
  }

  .gw-delivery__badge {
    min-width: 76px;
    padding: 10px 6px 8px;
  }

  .gw-delivery__badge-icon {
    font-size: 20px;
    margin-bottom: 4px;
  }

  .gw-delivery__badge-label {
    font-size: 12px;
  }

  .gw-delivery__badge-subtitle {
    font-size: 10px;
  }

  .gw-delivery__tariff-card {
    padding: 12px;
  }

  .gw-delivery__tariff-name {
    font-size: 13px;
  }

  .gw-delivery__tariff-price {
    font-size: 15px;
  }

  .gw-delivery__greenwax-info {
    padding: 16px;
  }

  .gw-delivery__address {
    padding: 16px;
  }
}
`;

export function injectStyles(): void {
  if (document.getElementById('gw-delivery-styles')) return;

  const style = document.createElement('style');
  style.id = 'gw-delivery-styles';
  style.textContent = STYLES;
  document.head.appendChild(style);
}
